var utils;

utils = require('derby-passport/utils');

exports.init = function(model) {};

exports.create = function(model, dom) {};

exports.submitPasswordReset = function() {
  var $q, model, rootModel;
  model = this.model;
  rootModel = model.parent().parent();
  $q = rootModel.query('auths', {
    'local.email': model.get('passwordResetEmail').toLowerCase(),
    $limit: 1
  });
  return $q.fetch(function(err) {
    try {
      if (err) {
        throw new Error(err);
      }
      if (!$q.get()[0]) {
        throw new Error('Email not registered.');
      } else {
        model.set('errors.passwordReset', '');
        return typeof $ !== "undefined" && $ !== null ? $.ajax({
          type: 'POST',
          url: "/password-reset",
          data: {
            email: model.get('passwordResetEmail')
          },
          success: function(response) {
            return model.set('success.passwordReset', response);
          },
          error: function(e) {
            console.log(e);
            throw e.responseText;
          }
        }) : void 0;
      }
    } catch (err) {
      return model.set('errors.passwordReset', err.message);
    }
  });
};
